import { useContext } from "react";
import { useAuth } from "../../auth/useAuth";
import { Domains } from "../../data/Domains";
import { HttpMethods } from "../../data/HttpMethods";
import { NotificationTypes } from "../../data/NotificationTypes";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { getHttpOptions, fetchData } from "../../utils/http.util";


export const useUploadRules = ( ): {

    uploadVillageRules( domain: Domains, htmlText: string, startFrom: string, version: string, isThirdParty?: boolean ): Promise< boolean >

} => {

    const { functionKey, setNotificationText, setNotificationType } = useContext( VillageConsoleContext );
    const { getIdToken } = useAuth( );


    const uploadVillageRules = async ( domain: Domains, htmlText: string, startFrom: string, version: string, isThirdParty?: boolean ): Promise<boolean> => {

        const query = `${process.env.REACT_APP_API_URL}/rules`;

        const formData = new FormData( );

        formData.append( 'domain', domain );
        formData.append( 'htmlText', htmlText );
        formData.append( 'startFrom', startFrom );
        formData.append( 'version', version );

        if( typeof isThirdParty !== 'undefined' ) {
            
            formData.append( 'isThirdParty', isThirdParty.toString( ) );

        }

        const idToken: string = await getIdToken( );
        const options = getHttpOptions( idToken, functionKey!, HttpMethods.Post, formData );

        const response = await fetchData( options, query );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( 'Error uploading village rules' );
            return false;

        }

        setNotificationType( NotificationTypes.Success );
        setNotificationText( 'Village rules successfully uploaded' );

        return true;

    };

    return {

        uploadVillageRules

    };

};